// extracted by mini-css-extract-plugin
export default {"gallerySection":"gallery_gallerySection__R0rF0"};